import React, {useEffect, useState} from 'react';
import styled, { keyframes } from 'styled-components';

const panAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const HomePageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;

  background: ${({ bgUrl }) => bgUrl
    ? `url(${bgUrl}) no-repeat center center`
    : 'none'};
  background-size: cover;
  animation: ${panAnimation} 20s linear infinite;
`;

const TopImage = styled.img`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  height: auto;
  border-radius: 8px;
  z-index: 1; /* Ensures it appears above the background */
`;

const Content = styled.div`
  position: relative;
  text-align: center;
  z-index: 1;
  padding-top: 75px;

  /* Add responsive padding for mobile */
  @media (max-width: 768px) {
    padding-top: 150px;
  }

  h1 {
    font-family: 'Chewy', cursive;
    font-size: 14pt; /* 12-point font size */
    color: white;
    max-width: 60%; /* Width between 0.25 and 0.75 of the screen */
    margin: 0 auto; /* Center the text */
    text-align: justify;
  }
`;

function HomePage() {
  const [bgUrl, setBgUrl] = useState(null);

  useEffect(() => {
    const testImg = new Image();
    testImg.src = 'https://res.cloudinary.com/dgtjqqufz/image/upload/v1740556057/econoverse-images/vbatfyo7tmjy1lr90pdx.gif';

    testImg.onload = () => {
      setBgUrl(testImg.src);
    };

    testImg.onerror = () => {
      setBgUrl('/images/default_image.png');
    };
  }, []);

  const topImageUrl = "https://res.cloudinary.com/dgtjqqufz/image/upload/v1740556064/econoverse-images/oua2wpjjrxppiai0y9gj.jpg";

  const welcomeMessage = "Welcome to EconoVerse! This Blog’s mission is to make sense of global economics in a way that’s both engaging and practical. By following economic trends, you can make better decisions, understand the world around you, and even see opportunities in your own life. Join us and let’s make sense of the economy together!";

  return (
    <HomePageContainer bgUrl={bgUrl}>
      <TopImage
        src={topImageUrl} alt="EconoVerse Logo Big Version"
        onError={(e) => {
          e.currentTarget.src = '/images/default_image.png';
        }}
      />
      <Content>
        <h1>{welcomeMessage}</h1>
      </Content>
    </HomePageContainer>
  );
}

export default HomePage;
